'use client'

import NextError from 'next/error'
import posthog from 'posthog-js'
import { useEffect } from 'react'

export default function ErrorPage({
	error,
}: {
	error: Error & { digest?: string }
}) {
	useEffect(() => {
		// Log the error to PostHog
		posthog.captureException(error)
	}, [error])

	return <NextError statusCode={undefined as any} />
}
